import React, { useState } from 'react';

const FaqsSection = ({ data }) => {
    const [activeAccordion, setActiveAccordion] = useState(0);

    const toggleAccordion = (index) => {
        setActiveAccordion(activeAccordion === index ? null : index);
    };

    return (
        <div className="faqs-container">
            <h2 className="faqs-title">FAQS</h2>

            <div className="accordion-container">
                {data?.faqs?.map((faq, idx) => (
                    <div className="accordion-item" key={idx}>
                        <button
                            className={`accordion-header${activeAccordion === idx ? " active" : ""}`}
                            onClick={() => toggleAccordion(idx)}
                        >
                            {faq.faq_title}
                            <span className="accordion-icon"></span>
                        </button>
                        <div className={`accordion-content${activeAccordion === idx ? " active" : ""}`}>
                            <p className="accordion-text">{faq.faq_paragraph}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqsSection;